module.exports = __webpack_public_path__ + "img/news_post_5.b658b55e.png";